import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ClientCreateModal from "../../../components/modals/ClientCreateModal";
import ClientProposal from "../../../components/client/ClientProposal";
import ClientDetailsHeader from "../../../components/client/ClientDetailsHeader";
import DeleteModal from "../../../components/modals/DeleteModal";
import MyNavigator from "../../../components/misc/MyNavigator";
import NavBar from "../../../components/misc/NavBar";
import SideBar from "../../../components/misc/SideBar";
import MainContext from "../../../context/MainContext";
import useIsMobile from "../../../hooks/useIsMobile";
import useToggle from "../../../hooks/useToggle";
import OfferCreateModal from "../../../components/modals/OfferCreateModal";
import useClient from "../../../api/hooks/useClients";
import useLogMessage from "../../../hooks/useLogMessage";
import LogMessage from "../../../components/misc/LogMessage";
import { logMsgBgColors } from "../../../consts/misc";
import useOffer from "../../../api/hooks/useOffers";

const ClientDetailsPage = (props: any) => {
  const { isMobile } = useIsMobile();
  const navigateNow = useToggle(false);
  const menuToggler = useToggle(false);

  const { client, setClient } = useContext(MainContext);
  const { RESPONSES, RESULTS, CTAs } = useClient();
  const offerHook = useOffer();
  const logMessage = useLogMessage();
  const [tempClientName, setTempClientName] = useState("");

  /* Modals */
  const editClientModalToggler = useToggle(false);
  const deleteClientModalToggler = useToggle(false);
  const createProposalModalToggler = useToggle(false);

  const anyModalOpen =
    editClientModalToggler.isToggled ||
    deleteClientModalToggler.isToggled ||
    createProposalModalToggler.isToggled;

  /* Forms */
  const deleteClientForm = useForm();
  const editClientForm = useForm();
  const createProposalForm = useForm();

  const tempLoading = useToggle(false);

  useEffect(() => {
    if (tempLoading.isToggled) {
      /* caricamento */
      logMessage.setMessageTimer(20000);
      logMessage.write("subject", "Loading . . .");
      logMessage.write("bgColor", logMsgBgColors.loading);
    } else if (!tempLoading.isToggled) {
      logMessage.setMessageTimer(null);
    }
  }, [tempLoading.isToggled]);

  const onProposalCreateSubmit = (data: any) => {
    tempLoading.setIsToggled(true);
    offerHook.CTAs.createOffer(data);
  };
  const onClientEditSubmit = (data: any) => {
    if (client) {
      tempLoading.setIsToggled(true);
      const id = client?.id;
      CTAs.updateClient(id, data);
    }
  };

  const onDeleteClientSubmit = (data: any) => {
    if (client) {
      tempLoading.setIsToggled(true);
      setTempClientName(client.name);
      const id = client.id;
      CTAs.deleteClient(id);
    }
  };

  useEffect(() => {
    /* console.log(RESPONSES.updateResponse, RESULTS.updateResult);  */
    if (RESPONSES.updateResponse?.ok) {
      tempLoading.setIsToggled(false);
      logMessage.write("subject", tempClientName);
      logMessage.write("other_text", " successfully modified!");
      logMessage.write("bgColor", logMsgBgColors.correct);
      setClient(RESULTS.updateResult?.client);
      editClientModalToggler.toggle();
    } else if (RESPONSES.updateResponse?.ok === false) {
      tempLoading.setIsToggled(false);
      logMessage.write("subject", `error: ${RESPONSES.updateResponse?.status}`);
      logMessage.write("other_text", `${RESPONSES.updateResponse?.statusText}`);
      logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [RESPONSES.updateResponse]);

  useEffect(() => {
    /* console.log(RESPONSES.deleteResponse, RESULTS.deleteResult); */
    if (RESPONSES.deleteResponse?.ok) {
      tempLoading.setIsToggled(false);
      logMessage.write("subject", tempClientName);
      logMessage.write("other_text", " successfully deleted!");
      logMessage.write("bgColor", logMsgBgColors.correct);
      setTimeout(() => {
        logMessage.write("subject", "");
        logMessage.write("other_text", "Back to Clients...");
      }, 2000);
      deleteClientModalToggler.toggle();
      setTimeout(() => {
        navigateNow.toggle();
      }, 3000);
    } else if (RESPONSES.deleteResponse?.ok === false) {
      tempLoading.setIsToggled(false);
      logMessage.write("subject", `error: ${RESPONSES.deleteResponse?.status}`);
      logMessage.write("other_text", `${RESPONSES.deleteResponse?.statusText}`);
      logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [RESPONSES.deleteResponse]);

  /* CREATE PROPOSAL using useOffer/create Api
  useEffect(() => {
     console.log();  
  }, []); */

  useEffect(() => {
    if (client === null && window.location.pathname.includes("/clients/")) {
      navigateNow.setIsToggled(true);
    }
  }, []);

  return (
    <div className="page-wrapper">
      <form onSubmit={createProposalForm.handleSubmit(onProposalCreateSubmit)}>
        {createProposalModalToggler.isToggled && (
          <OfferCreateModal
            toggler={createProposalModalToggler}
            register={createProposalForm.register}
            getValues={createProposalForm.getValues}
            setValue={createProposalForm.setValue}
            errors={createProposalForm.formState.errors}
          />
        )}
      </form>
      <form onSubmit={editClientForm.handleSubmit(onClientEditSubmit)}>
        {editClientModalToggler.isToggled && (
          <ClientCreateModal
            toggler={editClientModalToggler}
            register={editClientForm.register}
            errors={editClientForm.formState.errors}
            reset={editClientForm.reset}
            onEdit={true}
            client={client}
            deleteToggler={deleteClientModalToggler}
          />
        )}
      </form>
      <form onSubmit={deleteClientForm.handleSubmit(onDeleteClientSubmit)}>
        {deleteClientModalToggler.isToggled && (
          <DeleteModal
            toggler={deleteClientModalToggler}
            register={deleteClientForm.register}
            reset={deleteClientForm.reset}
            client={client}
            deleteType={"client"}
          />
        )}
      </form>

      <MyNavigator path={`/clients`} trigger={navigateNow} />
      {(!isMobile || menuToggler.isToggled) && (
        <SideBar toggler={menuToggler} />
      )}
      <div>
        {isMobile && <NavBar toggler={menuToggler} />}
        <div
          className={`page-content ${
            isMobile && menuToggler.isToggled
              ? menuToggler.isToggledSecondary
                ? "slide-right"
                : "slide-left"
              : ""
          }`}
          style={{
            maxWidth: isMobile ? "" : "calc(100vw - 256px)",
            minWidth: isMobile ? "" : "1105px",
            marginLeft: isMobile
              ? menuToggler.isToggled
                ? "256px"
                : ""
              : "256px",
            display: anyModalOpen && isMobile ? "none" : "",
          }}
        >
          {logMessage.isToggled && (
            <LogMessage
              text={{
                subject: logMessage.message.subject,
                other_text: logMessage.message.other_text,
                complement: logMessage.message.complement,
              }}
              bgColor={logMessage.message.bgColor}
            />
          )}
          <ClientDetailsHeader
            {...client}
            createProposalModalToggler={createProposalModalToggler}
            editClientModalToggler={editClientModalToggler}
          />

          <div
            className="client-details-card shadow"
            style={{
              width: isMobile ? "345px" : "",
              margin: isMobile ? "28px 15px" : "",
              height: isMobile ? "fit-content" : "",
            }}
          >
            <div
              className="client-details-card-info"
              style={{
                margin: isMobile ? "48px 24px" : "",
              }}
            >
              <p
                className="model-details-card-info-name"
                style={{ fontSize: isMobile ? "32px" : "" }}
              >
                {client?.name}
              </p>
              <div className="client-details-card-info-spec-wrapper">
                <div className="client-details-card-info-spec-box">
                  <p className="client-details-card-info-spec-field">
                    Location
                  </p>
                  <p className="client-details-card-info-spec-value">
                    {client?.location}
                  </p>
                </div>

                <div
                  className="client-details-card-row "
                  style={{
                    flexDirection: isMobile ? "column" : "row",
                    gap: isMobile ? "10px" : "",
                  }}
                >
                  <div className="client-details-card-info-spec-box">
                    <p className="client-details-card-info-spec-field">
                      Referent
                    </p>
                    <p className="client-details-card-info-spec-value">
                      {client?.referent_name}
                    </p>
                  </div>
                  <div className="client-details-card-info-spec-box">
                    <p className="client-details-card-info-spec-field">
                      E-mail
                    </p>
                    <p className="client-details-card-info-spec-value">
                      {client?.mail}
                    </p>
                  </div>
                </div>
                <div
                  className="client-details-card-row"
                  style={{
                    flexDirection: isMobile ? "column" : "row",
                    gap: isMobile ? "10px" : "",
                  }}
                >
                  <div className="client-details-card-info-spec-box">
                    <p className="client-details-card-info-spec-field">Phone</p>
                    <p className="client-details-card-info-spec-value">
                      {client?.phone}
                    </p>
                  </div>
                  <div className="client-details-card-info-spec-box">
                    <p className="client-details-card-info-spec-field">
                      Mobile
                    </p>
                    <p className="client-details-card-info-spec-value">
                      {client?.mobile}
                    </p>
                  </div>
                </div>
                <div className="client-details-card-info-spec-box">
                  <p className="client-details-card-info-spec-field">Address</p>
                  <p className="client-details-card-info-spec-value">
                    {client?.address}
                  </p>
                </div>
                <div className="client-details-card-info-spec-box">
                  <p className="client-details-card-info-spec-field">Website</p>
                  <p className="client-details-card-info-spec-value">
                    {client?.website}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {client && <ClientProposal client={client} />}
        </div>
      </div>
    </div>
  );
};
export default ClientDetailsPage;
